import { fetchAemRecipeData } from "@/services/aem";
import { createAsyncThunk } from "@reduxjs/toolkit";
export const getAemData = createAsyncThunk("/aem/getAemData", async () => {
  const res = await fetchAemRecipeData();
  return res;
});
